
<template>
  <v-container>
    <v-snackbar v-model="ShowSnackbar" :timeout="5000">
      {{ error }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="error = ''">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-data-table
      :headers="headers"
      :items="workers"
      class="elevation-1"
      :sort-by="['prioritaOrdinamento', 'descrizione']"
      :sort-desc="false"
      :loading="loading"
      item-key="descrizione"
      value="workers"
      :search="search"
      :items-per-page="-1"
      :show-select="Boolean(this.showSelect)"
      v-model="selectedItems"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Operai</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            class="mx-5"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
          <v-dialog v-model="dialog" max-width="800px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                Nuovo
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-card-text>
                      <v-container>
                        <h2>Informazioni operatore</h2>
                        <v-text-field
                          label="Nominativo"
                          type="text"
                          v-model="editedWorker.descrizione"
                        ></v-text-field>
                        <v-spacer></v-spacer>
                        <h2>Informazioni di accesso</h2>
                        <v-divider></v-divider>
                        <v-text-field
                          label="Username"
                          type="text"
                          :readonly="editedWorker.utente.idRuolo == 1"
                          v-model="editedWorker.utente.username"
                        ></v-text-field>
                        <v-text-field
                          label="Password"
                          v-if="editedWorker.utente.idRuolo != 1"
                          type="password"
                          v-model="editedWorker.utente.password"
                        ></v-text-field>
                        <v-select
                          :items="roles"
                          v-if="editedWorker.utente.idRuolo != 1"
                          label="Ruolo"
                          item-text="description"
                          item-value="id"
                          v-model="editedWorker.utente.idRuolo"
                        >
                        </v-select>
                      </v-container>
                      <v-icon>mdi-format-color-fill</v-icon> Colore in
                      calendario:
                      <v-menu
                        ref="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            v-bind:style="{
                              display: 'inline-block',
                              width: '30px !important',
                              'min-width': '0 !important',
                              height: '30px',
                              'border-radius': '30px',
                              'background-color': userColor,
                            }"
                          >
                          </v-btn>
                          <!-- <v-btn v-bind="attrs" v-on="on" v-if="color==null">
                                                      Seleziona colore
                                                    </v-btn>
                                                    <v-btn v-bind="attrs" v-on="on" v-if="color!=null">
                                                      {{color}}
                                                    </v-btn> -->
                        </template>
                        <v-color-picker
                          class="ma-2"
                          elevation="3"
                          v-model="userColor"
                          hide-canvas
                          hide-inputs
                          hide-mode-switch
                          hide-sliders
                          mode="rgba"
                          show-swatches
                          swatches-max-height="200px"
                        ></v-color-picker>
                        <!-- <v-spacer></v-spacer> -->
                        <!-- <v-btn text color="primary" @click="menu = false">
                                                  Cancel
                                                </v-btn>
                                                <v-btn
                                                  text
                                                  color="primary"
                                                  @click="$refs.menu.save(date)"
                                                >
                                                  OK
                                                </v-btn> -->
                      </v-menu>
                    </v-card-text>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" text @click="save"> Save </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-space></v-space>
          <v-dialog v-model="dialogSort" max-width="600px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="canEditOrder()"
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
                style="margin-left: 7px"
              >
                Modifica ordine
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline"
                  >Modifica l'ordine con cui verranno visualizzati gli operatori
                  nel planner</span
                >
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-data-table
                      :headers="headersSorter"
                      :items="workers"
                      class="elevation-1"
                      :loading="loading"
                      item-key="descrizione"
                      :sort-by="['prioritaOrdinamento', 'descrizione']"
                      value="workers"
                      :search="search"
                      v-sortable-data-table
                      :items-per-page="-1"
                      :show-select="Boolean(false)"
                      v-model="selectedItems"
                    >
                      <template v-slot:item="{ item }">
                        <tr :id="item.idRisorsa" class="sortable-resource-item">
                          <td>
                            <b>{{ item.descrizione }}</b>
                          </td>
                        </tr>
                      </template>

                      <template v-slot:pagination> </template>
                    </v-data-table>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeSortDialog"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="saveResourcesOrder"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="600px">
            <v-card>
              <v-card-title class="headline"
                >Are you sure you want to delete this worker?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
      <!-- <template v-slot:no-data>
              <v-btn color="primary" @click="initialize"> Reset </v-btn>
            </template> -->

      <v-snackbar v-model="ShowSnackbar" :timeout="5000">
        {{ error }}

        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="error = ''">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-data-table>
  </v-container>
</template>
<script>
import Sortable from "sortablejs";

import SessionHelper from "../../utils/SessionHelper";
import EasyPlanClient from "../../utils/EasyPlanClient";
export default {
  props: ["showSelect"],
  components:[SessionHelper],
  data: () => ({
    dialog: false,
    loading: false,
    dialogDelete: false,
    dialogSort: false,
    error: "",
    search: "",
    headers: [
      {
        text: "Ordine",
        value: "prioritaOrdinamento",
        width: "40px",
        align: "right",
      },
      { text: "Nominativo", value: "descrizione" },
      { text: "Email", value: "mail" },

      { text: "Actions", value: "actions", sortable: false },
    ],
    headersSorter: [
      { text: "Nominativo", value: "descrizione", sortable: false },
    ],
    workers: [],
    selectedItemsArr: [],
    roles: [],
    editedIndex: -1,
    editedWorker: {
      descrizione: "",
      mail: "",
      utente: { password: "", username: "", idRuolo: 0, colore: "#fff" },
    },
    defaultItem: {
      descrizione: "",
      mail: "",
      utente: { password: "", username: "", idRuolo: 0, colore: "#fff" },
    },
  }),

  computed: {
    userColor: {
      get() {
        console.debug(this.editedWorker.utente.colore);
        if (
          this.editedWorker.utente.colore != null &&
          this.editedWorker.utente.colore != undefined
        )
          return this.editedWorker.utente.colore;
        else return "transparent";
      },
      set(value) {
        this.editedWorker.utente.colore = value;
        console.debug(value);
      },
    },
    selectedItems: {
      get() {
        return this.selectedItemsArr;
      },
      set(value) {
        this.selectedItemsArr = value;
        console.debug("raising event itemSelected...");
        this.$emit("item-selected", this.selectedItemsArr);
      },
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Worker" : "Edit Worker";
    },
    ShowSnackbar: {
      get() {
        return this.error.length > 0;
      },
      set(value) {
        if (!value) this.error = "";
      },
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },

    // SelectedItems: function (val){
    //   this.selectedItems = val;
    // }
  },

  created() {
    this.initialize();

    // if(this.SelectedItems != undefined)
    // this.selectedItems = this.SelectedItems;
  },

  directives: {
    sortableDataTable: {
      bind(el, binding, vnode) {
        const options = {
          animation: 150,
          onUpdate: function (event) {
            vnode.child.$emit("sorted", event);
          },
        };
        Sortable.create(el.getElementsByTagName("tbody")[0], options);
      },
    },
  },
  methods: {
    canEditOrder:function(){
      console.debug("Controllo se ha i permessi per modificare l'ordine dei lavoratori");
      let canDo=SessionHelper.checkPermission('EDIT_RESOURCE_ORDER');
      
      console.debug("Ha i permessi per modificare l'ordine dei lavoratori:",canDo);
      return canDo;
    },
    resetFormData: function () {
      this.editedWorker = {
        descrizione: "",
        mail: "",
        utente: { password: "", username: "", idRuolo: 0 },
      };
      this.editedIndex = -1;
    },
    closeSortDialog() {
      this.dialogSort = false;
    },
    async saveResourcesOrder() {
      
      let resouresItems = document.body.getElementsByClassName(
        "sortable-resource-item"
      );
      let sorted = [];
      //console.debug("resouresItems", resouresItems);
      let sortOrderToSave=[];
      for (let i = 0; i < resouresItems.length; i++) {
        let resId = resouresItems[i].id;
        let worker = this.workers.find((w) => w.idRisorsa == resId);

        worker.prioritaOrdinamento = i;
        console.debug(
          "ord:" +
            worker.prioritaOrdinamento +
            "\tresId:" +
            worker.idRisorsa +
            "\tdesc:" +
            worker.descrizione
        );
        sorted.push(worker);
        sortOrderToSave.push({idRisorsa:resId,prioritaOrdinamento:i});
      }
      this.workers = [];
          this.$forceUpdate();
      localStorage.resourceOrder=JSON.stringify(sortOrderToSave);
      this.workers = sorted;
      let t=this;
      console.debug("AGGIPORNO SORT, ORDER");
      
      this.dialogSort = false;
      await EasyPlanClient.Resources.ChangeSortOrder(
        t.$route.params.companyAlias,
        t.workers
      ).then(()=>{
        
      });
  
     
    },
    loadRoles() {
      console.log("loading roles....");
      EasyPlanClient.Role.GetAll(this.$route.params.companyAlias)
        .then((res) => {
          this.roles = res.data.data;
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
    initialize() {
      if (
        localStorage.userToken == undefined ||
        localStorage.userToken == "null"
      ) {
        console.debug("logging off");
        localStorage.userToken = null;

        this.$router.push({
          name: "login",
          params: { companyAlias: this.$route.params.companyAlias },
        });
      }
      this.loadRoles();
      this.loadWorkers();
    },
    loadWorkers() {
      this.loading = true;
      console.log("loading workers...");

      // let resourceOrder=[];
      // if(localStorage.resourceOrder){
      //   resourceOrder=JSON.parse(localStorage.resourceOrder);
      // } 
      EasyPlanClient.Resources.GetAllOperators(this.$route.params.companyAlias)
        .then((res) => {
          
          let sorted=[]
          for (let i = 0; i < res.data.data.length; i++) {
            if (
              res.data.data[i].utente == null ||
              res.data.data[i].utente == undefined
            )
              res.data.data[i].utente = { ...this.defaultItem.utente };
              // let ord=resourceOrder.find(r=>r.idRisorsa==res.data.data[i].idRisorsa);
               
              
            console.debug("PRIOR ORD", res.data.data[i].prioritaOrdinamento);
            // if(ord)
            //   res.data.data[i].prioritaOrdinamento=ord.prioritaOrdinamento;
            console.debug("PRIOR ORD BACKUP", res.data.data[i].prioritaOrdinamento);
          }

          this.workers = res.data.data.sort(w=>w.prioritaOrdinamento);
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    insertWorker(worker) {
      EasyPlanClient.Resources.InsertWorker(
        this.$route.params.companyAlias,
        worker.descrizione,
        0,
        worker.utente
      )
        .then((res) => {
          console.debug("risposta add worker:");
          console.debug(res);
          this.resetFormData();
          this.workers.push(res.data.data);
          this.loadWorkers();
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },

    editWorker(worker) {
      EasyPlanClient.Resources.Update(this.$route.params.companyAlias, worker)
        .then((res) => {
          console.debug("risposta edit worker:");
          console.debug(res);
          this.resetFormData();
          this.loadWorkers();
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },

    editItem(item) {
      this.editedIndex = this.workers.indexOf(item);

      this.editedWorker = Object.assign({}, item);
      EasyPlanClient.User.FindByResourceId(
        this.$route.params.companyAlias,
        this.editedWorker.idRisorsa
      )
        .then((res) => {
          console.debug("risposta find userbyResId:", res);
          this.editedWorker.utente = res.data.data;
          this.dialog = true;
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },

    deleteItem(item) {
      this.editedIndex = this.workers.indexOf(item);
      this.editedWorker = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      EasyPlanClient.Resources.Delete(
        this.$route.params.companyAlias,
        this.editedWorker.idRisorsa
      ).then((res) => {
        this.workers.splice(this.editedIndex, 1);
        this.closeDelete();
      });
    },

    close() {
      this.resetFormData();
      this.dialog = false;
    },

    closeDelete() {
      this.resetFormData();
      this.dialogDelete = false;
    },

    save() {
      if (this.editedIndex > -1) {
        this.editWorker(this.editedWorker);
        Object.assign(this.workers[this.editedIndex], this.editedWorker);
      } else {
        this.insertWorker(this.editedWorker);
      }
      this.resetFormData();
      this.close();
    },
  },
};
</script>
